export default "__VITE_ASSET__be698bcb__"